<template>
  <div class="helpResult">
    <div class="helpResult_container">
      <div class="helpResult_list">
        <div
          class="helpResult_column"
          v-for="result in searchResult"
          :key="result.slug"
        >
          <div class="helpResult_icon">
            <component :is="slugIcons[result.slug]" />
          </div>
          <div class="helpResult_title">{{ result.title }}</div>
          <ul class="helpResult_links">
            <li v-for="link in result.items" :key="link.link">
              <Link :href="link.link">{{ link.label }}</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import HelpBox from "@/components/icons/help/IconHelpBox.vue";
import HelpBriefcase from "@/components/icons/help/IconHelpBriefcase.vue";
import HelpFirstline from "@/components/icons/help/IconHelpFirstline.vue";
import HelpFolderOpen from "@/components/icons/help/IconHelpFolderOpen.vue";
import HelpLayer from "@/components/icons/help/IconHelpLayer.vue";
import HelpPause from "@/components/icons/help/IconHelpPause.vue";
import HelpQuoteUp from "@/components/icons/help/IconHelpQuoteUp.vue";
import HelpScreenmirroring from "@/components/icons/help/IconHelpScreenmirroring.vue";
import HelpTextalignLeft from "@/components/icons/help/IconHelpTextalignLeft.vue";
import { Link } from "@inertiajs/vue2";

const slugIcons = {
  slug0: HelpFirstline,
  slug1: HelpFolderOpen,
  slug2: HelpLayer,
  slug3: HelpPause,
  slug4: HelpQuoteUp,
  slug5: HelpScreenmirroring,
  slug6: HelpBox,
  slug7: HelpBriefcase,
  slug8: HelpTextalignLeft,
};

const searchResult = [
  {
    slug: "slug0",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug1",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug2",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug3",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug4",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug5",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug6",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug7",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
  {
    slug: "slug8",
    title: "Getting started",
    items: [
      {
        label: "Import your product catalog",
        link: "/help/1",
      },
      {
        label: "Adding feed templates",
        link: "/help/2",
      },
      {
        label: "Setting up your feed",
        link: "/help/3",
      },
      {
        label: "Publish a feed",
        link: "/help/4",
      },
    ],
  },
];
</script>

<style lang="scss">
.helpResult {
  position: relative;
  z-index: 1;

  &_container {
    border-radius: 30px;
    background-color: #ffffff;
    max-width: 1680px;

    width: calc(100% - 120px);
    margin: 0 auto;
    padding: 140px 0 16px;

    @media screen and (max-width: 1540px) {
      width: calc(100% - 160px);
      padding: 80px 0 16px;
    }

    @media screen and (max-width: 1100px) {
      width: 100%;
      padding: 56px 32px 16px;
    }

    @media screen and (max-width: 767px) {
      width: 100%;
      padding: 40px 16px 16px;
    }
  }

  &_list {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0 auto;
    padding: 0 140px;

    @media screen and (max-width: 1540px) {
      padding: 0 108px;
    }
    @media screen and (max-width: 1380px) {
      padding: 0 80px;
    }
    @media screen and (max-width: 1100px) {
      padding: 0;
    }
  }
  &_column {
    max-width: calc((100% - 24px * 2) / 3);
    width: 280px;
    margin-right: 100px;
    margin-bottom: 104px;

    &:nth-child(3n) {
      margin-right: 0;
    }
    @media screen and (max-width: 1540px) {
      margin-bottom: 65px;
      margin-right: 20px;
    }
    @media screen and (max-width: 1100px) {
      margin-bottom: 45px;
    }
    @media screen and (max-width: 860px) {
      max-width: calc(50% - 10px);
      margin-right: 20px;
      margin-bottom: 61px;
      &:nth-child(3n) {
        margin-right: 20px;
      }
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
    @media screen and (max-width: 560px) {
      max-width: 100%;
      margin-right: 0;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }

  &_icon {
    margin-bottom: 39px;

    @media screen and (max-width: 1540px) {
      margin-bottom: 19px;
    }
    @media screen and (max-width: 1100px) {
      margin-bottom: 14px;
    }
    @media screen and (max-width: 767px) {
      margin-bottom: 12px;
    }

    svg {
      width: 40px;
      height: 40px;
      fill: transparent;

      @media screen and (max-width: 1540px) {
        width: 32px;
        height: 32px;
      }

      path {
        fill: transparent;
      }
    }
  }
  &_title {
    color: #202020;
    font-family: "Bebas Neue Pro";
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    text-transform: uppercase;
    margin-bottom: 23px;

    @media screen and (max-width: 1540px) {
      font-size: 40px;
    }
    @media screen and (max-width: 1100px) {
      font-size: 28px;
      margin-bottom: 16px;
    }

    @media screen and (max-width: 767px) {
      font-size: 32px;
    }
  }
  &_links {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      margin-bottom: 17px;

      @media screen and (max-width: 1100px) {
        margin-bottom: 13px;
      }
      @media screen and (max-width: 767px) {
        margin-bottom: 18px;
      }
    }
    a {
      font-family: "ITC Avant Garde Gothic Std";
      font-size: 18px;
      font-style: normal;
      font-weight: 300;
      line-height: 175%;
      color: #878c95;
      text-decoration-color: #878c95;

      @media screen and (max-width: 1540px) {
        font-size: 14px;
      }
    }
  }
}
</style>
